import React from "react";
import { Checkbox } from "antd";
import MediaFetcher from "../library/MediaFetcher";

const GroupGridCard = ({ group, selected, onSelect, onClick }) => {
  const handleCheckboxClick = (e) => {
    e.stopPropagation();
    onSelect(group.id);
  };

  const medias = group.medias || [];
  const visibleMedias = medias.slice(0, 4);
  const overflowCount = medias.length - 4;

  return (
    <div
      className={`creative-group-card${selected ? " creative-group-card--selected" : ""}`}
      onClick={() => onClick(group)}
    >
      <div className="creative-group-card__checkbox">
        <Checkbox
          checked={selected}
          onClick={handleCheckboxClick}
        />
      </div>

      <div className="creative-group-card__gallery">
        {[0, 1, 2, 3].map((idx) => {
          const media = visibleMedias[idx];

          // Last cell shows overflow count if needed
          if (idx === 3 && overflowCount > 0) {
            return (
              <div key={idx} className="creative-group-card__gallery-cell creative-group-card__count-badge">
                +{overflowCount}
              </div>
            );
          }

          return (
            <div key={idx} className="creative-group-card__gallery-cell">
              {media && media.key ? (
                <MediaFetcher
                  mediaKey={media.key}
                  width="100%"
                  height="100%"
                  objectFit="cover"
                />
              ) : null}
            </div>
          );
        })}
      </div>

      <div className="creative-group-card__info">
        <div className="creative-group-card__name" title={group.name}>
          {group.name || "Untitled Group"}
        </div>
        <div className="creative-group-card__meta">
          {medias.length} unit{medias.length !== 1 ? "s" : ""}
        </div>
      </div>
    </div>
  );
};

export default GroupGridCard;
